import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashBoardState, SysIDashboards } from '../../types/types.dashboard';

const initialState: DashBoardState = { dashboards: [], loading: true };

export const dashboardsSlice = createSlice({
  name: 'dashboards',
  initialState,
  reducers: {
    setDashboards: (state, action: PayloadAction<SysIDashboards[]>) => {
      state.dashboards = action.payload;
      state.loading = false;
    },

    updateDashboardData: (state, action: PayloadAction<{ id: number; data: any }>) => {
      const dashboard = state.dashboards.find((x) => x.Db_Id === action.payload.id);
      if (dashboard) {
        dashboard.Data = action.payload.data;
        dashboard.UltimaActualizacion = new Date().toString();
        dashboard.Loading = false; // Marca como no cargando tras actualizar
      }
    },
    setLoading: (state, action: PayloadAction<number>) => {
      const dashboard = state.dashboards.find((x) => x.Db_Id === action.payload);
      if (dashboard) {
        dashboard.Loading = true;
      }
    },
    setLoadingPpal: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setDashboards, setLoading, setLoadingPpal, updateDashboardData } = dashboardsSlice.actions;
